import React, { useState, useEffect, useContext, useRef } from 'react';
import Card from '../card.component';
import Modal from '../modal/modal.component';
import {
    Col,
    Row,
} from 'react-bootstrap';
import { ConfigContextUtils } from '../../context/contextUtils.context';
import notification from '../notification.component';
import connect from '../../views/axios/axios.auth';
import general from '../../general/general.functions';

export const RecipientAddressEdit = ({ data = null, onUpdate, onClose, paises, estados }) => {

    const pais = useRef();
    const estado = useRef();
    const ciudad = useRef();
    const { setPreloader } = useContext(ConfigContextUtils);
    const [visible, setVisible] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [inputValues, setInputValues] = useState({
        address: '',
        country_id: null,
        city_id: null,
        state_id: null,
    });
    const [multiselect, setMultiselect] = useState(false);


    const changeText = (ev) => {
        setInputValues({
            ...inputValues,
            address: ev.target.value,
        })
    }

    useEffect(() => {
        if (data !== null) {
            setVisible(true);
            setInputValues({
                address: data.cliente_receptor_direccion_entrega,
                country_id: data.recipient_pais.id,
                city_id: data.recipient_ciudad.id,
                state_id: data.recipient_estado.id,
            });
        }
    // eslint-disable-next-line
    },[data]);

    useEffect(() => {
        if (!visible) {
            setInputValues({
                address: '',
                country_id: null,
                city_id: null,
                state_id: null,
            });
        }
    },[visible])

    useEffect(() => {
        if (paises.length && visible) {
         const pIndex = paises.findIndex(item => item.id === data.recipient_pais.id);
         pais.current.options.selectedIndex = pIndex + 1;
         setMultiselect(paises[pIndex].multiselect);
        }
    // eslint-disable-next-line
    },[paises, visible])

    useEffect(() => {
        if (multiselect && estados.length) {
            const pIndex = estados.findIndex(item => item.id === data.recipient_estado.id);
            estado.current.options.selectedIndex = pIndex + 1;
            getCiudad(data.recipient_estado.id);
        }
    // eslint-disable-next-line
    },[multiselect]);

    useEffect(() => {
        if (ciudades.length) {
            const pIndex = ciudades.findIndex(item => item.id === data.recipient_ciudad.id);
            ciudad.current.options.selectedIndex = pIndex + 1;
        }
    // eslint-disable-next-line
    },[ciudades]);

    const getCiudad = (stateId) => {
        general.ciudades({ estado: stateId }).then((respuesta) => {
            setCiudades(respuesta.ciudad);
        });
    }

    const selectOptionPais = (ev) => {
        if (ev.target.value === 'null') {
            setMultiselect(false);
            setInputValues({
                ...inputValues,
                country_id: null,
                city_id: null,
                state_id: null,
            })
        } else {
            const pIndex = paises.findIndex(item => item.id === parseInt(ev.target.value));
            setMultiselect(paises[pIndex].multiselect);
            setInputValues({
                ...inputValues,
                country_id: parseInt(ev.target.value),
                city_id: null,
                state_id: null,
            })
        }
    }

    const confirmupdate = () => {
        
        let isValid = true;

        if (inputValues.address.trim() === '') {
          isValid = false;
        }
        
        if (inputValues.country_id === null) {
            isValid = false;
        }

        if (multiselect) {
            if (inputValues.state_id === null) {
                isValid = false;
            }
            if (inputValues.city_id === null) {
                isValid = false;
            }
        }

        if (!isValid) {
          notification.warning('Complete todos los campos requeridos');
        } else {
          
          const payload = {
            ...inputValues,
            ...(!multiselect && { state_id: 26, city_id: 523 }),
            recipient_address_id: data.id,
          }

          setPreloader(true); 

          connect.post('/cliente/direccion-edit/', payload).then((response) => {
              if (response.data.error) {
                notification.warning(response.data.message);
              } else {
                notification.success(response.data.message);
                onUpdate(true);
                setVisible(false);
              }
              setPreloader(false);
          });

        }
    }

    const estadosOption = (ev) => {
        if (ev.target.value !== 'null') {
            setInputValues({
                ...inputValues,
                state_id: parseInt(ev.target.value),
                city_id: null,
            });
            getCiudad(ev.target.value);
        } else {
            setInputValues({
                ...inputValues,
                state_id: null,
            });  
        }
    }

    const ciudadOption = (ev) => {
        setInputValues({
            ...inputValues,
            city_id: ev.target.value === 'null' ? null : parseInt(ev.target.value),
        });  
    }

    const closeModal = () => {
        onClose();
        setVisible(false);
        setMultiselect(false);
    }


    return (
        <Modal show={visible}>
            <Card>
            {data !== null ?
                <>
                <Row>
                    <Col>
                      <h3 className="title-card">Editar dirección</h3>
                    </Col>
                </Row>
                <Row>
                    <Col lg={4}>
                        <small>País</small>
                        <select onChange={selectOptionPais} ref={pais} className={`form-control input-border`}>
                           <option value="null">Seleccione...</option>
                           {paises.map((item, index) => {
                               return <option value={item.id} key={index}>{item.country}</option>
                           })}
                        </select>
                    </Col>
                    {multiselect ? 
                    <>
                        <Col lg={4}>
                            <small>Estado</small>
                            <select onChange={estadosOption} ref={estado} className={`form-control input-border`}>
                                <option value="null">Seleccione...</option>
                                {estados.map((item, index) => {
                                     return <option value={item.id_estado} key={index}>{item.estado}</option>
                                })}
                            </select>
                        </Col>
                        <Col lg={4}>
                            <small>Ciudad</small>
                            <select onChange={ciudadOption} ref={ciudad} className={`form-control input-border`}>
                                <option value="null">Seleccione...</option>
                                {ciudades.map((item, index) => {
                                     return <option value={item.id_ciudad} key={index}>{item.ciudad}</option>
                                })}
                            </select>
                        </Col>
                    </>
                    : null }
                </Row>
                <Row>
                    <Col>
                        <small>Dirección</small>
                        <input type="text"
                            className={`form-control input-border`}
                            name="address"
                            defaultValue={inputValues.address}
                            onChange={changeText}
                        />
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <button 
                            onClick={closeModal}
                            type="button"
                            className="btnx btnx-warn mr-1"
                            >
                                Cerrar
                        </button>
                        <button 
                            onClick={confirmupdate}
                            type="button"
                            className="btnx btnx-warn mr-1"
                            >
                                Confirmar
                        </button>
                    </Col>
                </Row>
                </>
            : null}
            </Card>
        </Modal>
    )
}
